import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { StylerBorders } from "../../../../Constant";
import { STYLE_DATA } from "../../../../Data/UiKit/HelperClasses";
import { BorderRadius } from "./BorderRadius";
import { BorderColors } from "./BorderColor";
import { BorderWidths } from "./BorderWidth";
import { TextColor } from "./TextColors";
import CommonCardHeader from "../../../../Common/CommonCardHeader";

const StyleBorderCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={StylerBorders} span={STYLE_DATA} />
        <CardBody>
          <Row className="g-3">
            <BorderRadius />
            <BorderColors />
            <BorderWidths />
            <TextColor />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StyleBorderCart;
